/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function isCloneable(obj) {
    /* eslint-disable-next-line eqeqeq */
    return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}
export default function deepMerge(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    target = target || {};
    sources.forEach(function (source) {
        var obj = source || {};
        Object.keys(obj).forEach(function (key) {
            // @ts-ignore
            var value = obj[key];
            if (typeof value !== 'undefined') {
                if (isCloneable(value)) {
                    // @ts-ignore
                    target[key] = deepMerge(
                    // @ts-ignore
                    target[key] || (Array.isArray(value) ? [] : {}), value);
                }
                else {
                    // @ts-ignore
                    target[key] = value;
                }
            }
        });
    });
    return target;
}
